
import { useContext } from "react";

import qs from "qs";
import axios from "axios";
import config from "../Config";
import Cookies from "js-cookie";

import { UserSessionContext } from "../contexts/UserSessionContext";

export default function useUser() {
    return useContext(UserSessionContext);
}

function isUserDoctor(data) {
    const roles = data?.roles;
    if (roles === null || roles === undefined) return false;
    const doctorIndex = data.roles.find((value) => value === "doctor");
    return doctorIndex !== null && doctorIndex !== undefined;
}

function isUserClient(data) {
    const roles = data?.roles;
    if (roles === null || roles === undefined) return false;
    const clientIndex = data.roles.find((value) => value === "client");
    return clientIndex !== null && clientIndex !== undefined;
}

function hasRole(data, role) {
    const roles = data?.roles;
    if (roles === null || roles === undefined) return false;
    return roles.includes(role);
}

function copyConfig(config) {

    const cfg = { ...config };

    if (cfg.headers === null || cfg.headers === undefined) cfg.headers = {};

    cfg.paramsSerializer = params => {

        return qs.stringify(params, {indices: false, skipNulls: true});

    }

    return cfg;

}

async function getAuthorized(url, originalConf = {}) {

    const userToken = Cookies.get(config.authCookie);

    const cfg       = copyConfig(originalConf);

    cfg.headers.Authorization = `Bearer ${userToken}`;

    console.log(cfg);

    const response = await axios.get(url, cfg);

    return response;

}

async function putAuthorized(url, data, originalConf = {}) {

    const userToken = Cookies.get(config.authCookie);

    const cfg       = copyConfig(originalConf);   

    cfg.headers.Authorization = `Bearer ${userToken}`;

    const response  = await axios.put(url, data, cfg);

    return response;
    
}

async function patchAuthorized(url, data, originalConf = {}) {

    const userToken = Cookies.get(config.authCookie);

    const cfg       = copyConfig(originalConf);   

    cfg.headers.Authorization = `Bearer ${userToken}`;

    const response  = await axios.patch(url, data, cfg);

    return response;
    
}

async function postAuthorized(url, data, originalConf = {}) {

    const userToken = Cookies.get(config.authCookie);
    
    const cfg      = copyConfig(originalConf);

    cfg.headers.Authorization = `Bearer ${userToken}`;

    const response = await axios.post(url, data, cfg);

    return response;

}

async function deleteAuthorized(url, data, originalConf = {}) {

    const userToken = Cookies.get(config.authCookie);
    
    const cfg      = copyConfig(originalConf);

    cfg.headers.Authorization = `Bearer ${userToken}`;
    cfg.data                  = data

    const response = await axios.delete(url, cfg);

    return response;

}

export { isUserDoctor, isUserClient, hasRole, getAuthorized, putAuthorized, patchAuthorized, postAuthorized, deleteAuthorized };